var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class DenonAvr {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'PW?',
                next: /PW(STANDBY|ON)/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`PW?`, /(PWSTANDBY|PWON)/i, tags);
                return match[1] === 'PWON';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`${power ? 'PWON' : 'PWSTANDBY'}`, /(PWSTANDBY|PWON)/i, tags);
                if (power) {
                    this.state.busy.update(true);
                    this.busyTimeout.set(() => this.state.busy.update(false), 1000);
                    this.framework.suspend(1000);
                }
                return match[1] === 'PWON';
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`SI?`, /^SI(.+)/i, tags);
                return match[1];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`SI${value}`, /^SI(.+)/i, tags);
                return match[1];
            }),
            asyncHandlers: {
                regExp: /^SI(.+)/i,
                callback: (match) => {
                    this.state.videoMatrixRoutes.update('1', match[1]);
                },
            },
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`MV?`, /^MV(\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`MV${volume.toString().padStart(2, '0')}`, /^MV(\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            range: { max: 98, min: 35, round: 1 },
            asyncHandlers: [
                {
                    regExp: /^MV(\d+)/i,
                    callback: (match) => {
                        this.state.volume.update(parseInt(match[1], 10));
                    },
                },
                {
                    regExp: /^MVMAX\s+(\d+)/i,
                    callback: (match) => {
                        const range = this.volume.range;
                        range.max = parseInt(match[1], 10);
                        range.min = Math.max(range.max - 63, 0);
                    },
                },
            ],
            powerOffRestrictions: ['get', 'set'],
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`MU?`, /^MU(ON|OFF)/i, tags);
                return match[1].toLowerCase() === 'on';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`MU${mute ? 'ON' : 'OFF'}`, /^MU(ON|OFF)/i, tags);
                return match[1].toLowerCase() === 'on';
            }),
            asyncHandlers: {
                regExp: /^MU(ON|OFF)/i,
                callback: (match) => {
                    this.state.volumeMute.update(match[1].toLowerCase() === 'on');
                },
            },
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            { intervalMs: 5000, controls: ['power', 'volume', 'videoMatrixRoutes', 'volumeMute'] },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
DenonAvr.driverType = 'socketDriver';
DenonAvr.key = '-MX8p-KpucDrhrwWkkyQ';
DenonAvr.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
DenonAvr.socketOptions = [
    Object.assign(Object.assign({}, DenonAvr.baseSocketOptions), { port: 23 }),
    Object.assign(Object.assign({}, DenonAvr.baseSocketOptions), { port: 4999 }),
];
